export default __webpack_public_path__ + "static/media/Guneet.c4f18e36.jpeg";